import { apiClient } from '../Auth/apiClient';
import IFileUploadDto from '../Interfaces/IFileUploadDto';
import { IImageListRequest } from '../Interfaces/IFileDtos';
import ISearchBaseDto from '../Interfaces/ISearchBaseDto';
import { DictImageType } from '../Interfaces/Enums';

const FileServiceAPI = {
	GetFileUrl: async (id: number, width?: number, height?: number): Promise<any> => {
		let url = 'image';

		if (width && height) {
			url = url + '?width=' + width + '&height=' + height;
		}
		const response = await apiClient.post(url, { id });

		return response;
	},
	Upload: async (data: IFileUploadDto, imageType: DictImageType): Promise<any> => {
		const config = { headers: { ImageType: imageType } };

		const formData = new FormData();
		formData.append('file', data.file);
		formData.append('corporationId', data.corporationId);
		formData.append('name', data.name);
		formData.append('id', data.id);

		const response = await apiClient.post('upload', formData, config);
		return response.data;
	},
	Update: async (data: IFileUploadDto, imageType: DictImageType): Promise<any> => {
		return FileServiceAPI.Upload(data, imageType);
	},
	Add: async (data: IFileUploadDto, imageType: DictImageType): Promise<any> => {
		return FileServiceAPI.Upload(data, imageType);
	},
	GetImages: async (data: IImageListRequest, search?: ISearchBaseDto): Promise<any> => {
		const response = await apiClient.post('images', { ...search, ...data });
		return response.data;
	},
	Delete: async (id: number): Promise<any> => {
		const response = await apiClient.post('image/delete', { id: id });
		return response.data;
	},
};

export default FileServiceAPI;
